import { TweenMax } from 'gsap';
import { Sprite } from 'pixi.js';
import { GameAudio } from '../../../Config/Audio';
import { getGameSize } from '../../../Config/Levels';
import SoundManager from '../../../Sound/SoundManager';
import { getRandom } from '../../../Utils/Utils';
import { firework } from '../Animations';
import { Animation } from '../Animation';
import Core, { GameOrientation } from '../../../Core/Core';

/**
 * Sequence shown after fireworks booster. Contains animated sprites from the classes in Animations
 * @param wait -- time to complete is passed in since amount of fireworks varies
 * @param pos -- position to start firework sprite
 * @param boardTileSize -- current _boardSize to pass to firework anim
 * @param c -- container to add sprites to
 */

export const showFirecracker = async (
    wait: number,
    pos: PIXI.Point,
    boardTileSize: [number, number],
    c: PIXI.Container
) => {
    if (!pos) {
        return 'fail';
    }
    let resolve: VoidFunction;
    const promise = new Promise(resolve1 => (resolve = resolve1));
    const firecracker = new Sprite(PIXI.utils.TextureCache['mapui/booster-firecracker']);
    firecracker.anchor.set(0.5);
    firecracker.x = pos.x;
    firecracker.y = pos.y;
    const isPortrait = Core.orientation === GameOrientation.PORTRAIT;
    firecracker.rotation = isPortrait ? 30 * (Math.PI / 180) : -60 * (Math.PI / 180);
    c.addChild(firecracker);

    const animation = new Animation({});
    // animation.addDelay(600);
    animation.add(() => SoundManager.playSound(GameAudio.FIREWORKS_LAUNCH));
    animation.add(
        TweenMax.to(firecracker, 0.6, {
            x: !isPortrait ? getGameSize().gameWidth * 0.5 : pos.x,
            y: isPortrait ? getGameSize().gameHeight * 0.5 : pos.y,
            onComplete: () => {
                SoundManager.playSound(GameAudio.FIREWORKS_EXPLODE);
            },
        })
    );
    animation.addToLast(
        TweenMax.to(firecracker.scale, 0.6, {
            x: 1.6,
            y: 1.6,
            onComplete: () => {
                firework(boardTileSize, [firecracker.x, firecracker.y], c);

                firework(
                    boardTileSize,
                    [firecracker.x + getRandom(100, 250), firecracker.y + getRandom(100, 250)],
                    c,
                    true
                );

                firework(
                    boardTileSize,
                    [firecracker.x - getRandom(100, 250), firecracker.y - getRandom(100, 250)],
                    c,
                    true
                );
            },
        })
    );
    animation.add(
        TweenMax.to(firecracker.scale, 0.3, {
            x: 2,
            y: 2,
            oncomplete: () => {
                resolve();
                firecracker.destroy();
            },
        })
    );
    animation.addToLast(
        TweenMax.to(firecracker, 0.2, {
            alpha: 0,
            delay: 0.8,
        })
    );
    // animation.addDelay(wait);
    animation.play();
    await promise;

    return 'firecracker shown';
};
